export const manipulateLocalStorage = (key: string, value?: object) => {
  try {
    const existingValue = localStorage.getItem(key)

    if (!value) {
      localStorage.removeItem(key)
    } else {
      const parsedValue = existingValue ? JSON.parse(existingValue) : {}
      const newValue = { ...parsedValue, ...value }
      localStorage.setItem(key, JSON.stringify(newValue))

      return newValue
    }
  } catch (error) {
    console.error('Error manipulating localStorage:', error)
    // Handle error as needed, e.g., show a message to the user
  }
}
